import { QueryKeyConfig, MutationKeyConfig } from '../api-helper';

export const projectSubTypeApiKeyStore = {
  createProjectSubType: (): MutationKeyConfig => ({
    mutationKey: [`CREATE_PROJECT_SUBTYPE`],
    route: `/ProjectSubType`,
    action: 'POST',
  }),
  updateProjectSubType: (): MutationKeyConfig => ({
    mutationKey: [`UPDATE_PROJECT_SUBTYPE`],
    route: `/ProjectSubType`,
    action: 'PUT',
  }),
  deleteProjectSubType: (id: number): MutationKeyConfig => ({
    mutationKey: [`DELETE_PROJECT_SUBTYPE`, id],
    route: `/ProjectSubType/${id}`,
    action: 'DELETE',
  }),
  getProjectSubTypes: (): QueryKeyConfig => ({
    queryKey: [`GET_PROJECT_SUBTYPES`],
    route: `/ProjectSubType`,
  }),
};
